<template>
  <button
    type="button"
    @click="emit('toggle')"
    class="flex flex-col items-center hover:font-bold hover:text-blue-france-sun-113-hover group"
    :class="{ 'font-bold text-blue-france-sun-113': isActive }"
  >
    <span
      class="relative border border-grey-900 p-1 group-hover:border-l-4 group-hover:border-l-blue-france-sun-113-hover group-hover:bg-blue-france-975-hover"
      :class="{ 'border-l-4 border-l-blue-france-sun-113 bg-blue-france-975': isActive }"
    >
      <OhVueIcon :name="iconName" scale="1.25" />
      <span
        v-if="!isActive && count?.value"
        :aria-label="count.label"
        :title="count.label"
        class="absolute -top-2 -right-2 rounded-full w-4 h-4 p-1 bg-green-tilleul-verveine-925 text-xs flex justify-center items-center"
      >
        {{ count.value }}
      </span>
    </span>
    <span class="mt-1 text-sm">{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
import { OhVueIcon } from "oh-vue-icons";

type Props = {
  iconName: string;
  label: string;
  isActive: boolean;
  count?: {
    value: number;
    label: string;
  };
};
defineProps<Props>();
const emit = defineEmits<{ (e: "toggle"): void }>();
</script>
